import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=3576f525&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=3576f525&prod&lang=scss&scoped=true"
import style1 from "./PdfViewer.vue?vue&type=style&index=1&id=3576f525&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3576f525",
  null
  
)

export default component.exports